export default "__VITE_ASSET___wYNgpmu__"